import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { HiDocumentText } from "react-icons/hi";
import { useLocation } from "react-router-dom";

const SchemeSyllabus = () => {
  // Get current location to determine department
  const location = useLocation();

  // All documents organized by department
  const documentsByDepartment = {
    CSE: [
      {
        id: 1,
        title: "CSE 1 Sem Syllabus",
        link: "https://www.rgpvdiploma.in/SchemePDF/Syallabus/ISEMESTERCSE2025.pdf",
      },
      {
        id: 2,
        title: "CSE 2nd Sem Syllabus",
        link: "https://www.rgpvdiploma.in/SchemePDF/Syallabus/IISEMESTERCSE2025.pdf",
      },
      {
        id: 3,
        title: "CSE 3rd",
        link: "https://www.rgpvdiploma.in/SchemePDF/Syallabus/IIISEMESTERCSE2025.pdf",
      },
      {
        id: 4,
        title: "CSE 4th Sem Syllabus",
        link: "https://www.rgpvdiploma.in/SchemePDF/Syallabus/IVSEMESTERCSE2025.pdf",
      },
      {
        id: 5,
        title: "CSE 5th Sem Syllabus",
        link: "https://www.rgpvdiploma.in/SchemePDF/Syallabus/VSEMESTERCSE2025.pdf",
      },
      {
        id: 6,
        title: "CSE 6th Sem Syllabus",
        link: "https://www.rgpvdiploma.in/SchemePDF/Syallabus/VISEMESTERCSE2025.pdf",
      },
    ],
    MOM: [
      {
        id: 1,
        title: "MOM 1 Sem SCHEME",
        link: "https://www.gwpcs.org/admin/images/rgpv/MOM%201%20sem%20Scheme.pdf",
      },
      {
        id: 2,
        title: "MOM 1 Sem Syllabus",
        link: "https://www.gwpcs.org/admin/images/rgpv/MOM%201%20sem%20syllabus.pdf",
      },
      {
        id: 3,
        title: "MOM 2ND Sem Scheme",
        link: "https://www.gwpcs.org/admin/images/rgpv/ORDINANCE22.pdf",
      },
      {
        id: 4,
        title: "MOM 2ND Sem Syllabus",
        link: "https://www.gwpcs.org/admin/images/rgpv/MOM%202ND%20SEMESTER%20SYLLABUS.pdf",
      },
      {
        id: 5,
        title: "MOM 3RD Sem Scheme",
        link: "https://www.gwpcs.org/admin/images/rgpv/MOM%203RD%20SEMESTER%20SCHEME.pdf",
      },
      {
        id: 6,
        title: "MOM 3RD Sem Syllabus",
        link: "https://www.gwpcs.org/admin/images/rgpv/MOM%203RD%20SEMESTER%20SYLLABUS.pdf",
      },
      {
        id: 7,
        title: "MOM 4TH Sem Scheme",
        link: "https://www.gwpcs.org/admin/images/rgpv/MOM%204TH%20SEMESTER%20SCHEME.pdf",
      },
      {
        id: 8,
        title: "MOM 4TH Sem Syllabus",
        link: "https://www.gwpcs.org/admin/images/rgpv/MOM%204TH%20SEMESTER%20SYLLABUS.pdf",
      },
      {
        id: 9,
        title: "MOM 5TH Sem Scheme",
        link: "https://www.gwpcs.org/admin/images/rgpv/MOM%205TH%20SEMESTER%20SCHEME.pdf",
      },
      {
        id: 10,
        title: "MOM 5TH Sem Syllabus",
        link: "https://www.gwpcs.org/admin/images/rgpv/MOM%205TH%20SEMESTER%20SYLLABUS.pdf",
      },
      {
        id: 11,
        title: "MOM 6TH Sem Scheme",
        link: "https://www.gwpcs.org/admin/images/rgpv/MOM%206TH%20SEMESTER%20SCHEME.pdf",
      },
    ],
  };

  // State to track selected department
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    const path = location.pathname;
    console.log("Current path:", path);

    // Check for department-specific path like /department/cse/syllabus
    if (path.includes("/department/")) {
      const pathParts = path.split("/");
      console.log("Path parts:", pathParts);

      // Find the index of "department" in the path
      const deptIndex = pathParts.findIndex((part) => part === "department");

      if (deptIndex !== -1 && deptIndex + 1 < pathParts.length) {
        // Get the department code (cse, mom, etc.) and convert to uppercase
        const dept = pathParts[deptIndex + 1].toUpperCase();
        console.log("Detected department:", dept);

        if (documentsByDepartment[dept]) {
          setSelectedDepartment(dept);
          setDocuments(documentsByDepartment[dept]);
          return;
        }
      }
    }

    // If no department found or not a department path, render nothing
    // or show a "Department not found" message
    setSelectedDepartment(null);
    setDocuments([]);
  }, [location.pathname]);

  // If no department is selected or no documents found
  if (!selectedDepartment || documents.length === 0) {
    return (
      <div className="flex flex-col items-center justify-start  min-h-screen px-6 py-24 gap-12  bg-gray-50">
        {/* Heading */}
        <h1 className="text-4xl md:text-6xl font-bold text-teal-700 mb-8 text-center">
          Please Select Your Department
        </h1>

        {/* Button Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-lg">
          <a
            href="/department/cse/syllabus"
            className="bg-teal-500 text-white text-xl md:text-2xl font-semibold py-5 md:py-6 rounded-xl shadow-lg transform hover:scale-105 hover:bg-teal-600 transition duration-300 text-center"
          >
            CSE Syllabus
          </a>
          <a
            href="/department/mom/syllabus"
            className="bg-teal-500 text-white text-xl md:text-2xl font-semibold py-5 md:py-6 rounded-xl shadow-lg transform hover:scale-105 hover:bg-teal-600 transition duration-300 text-center"
          >
            MOM Syllabus
          </a>
        </div>
      </div>
    );
  }

  // Department-specific view - show documents for selected department
  return (
    <div className="flex flex-col items-center p-12 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-teal-500 mb-6 w-full text-center">
        {selectedDepartment} Department Scheme & Syllabus
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl w-full">
        {documents.map((doc, index) => (
          <motion.div
            key={doc.id}
            className="col-lg-4 col-md-6 col-sm-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 * index }}
          >
            <div className="featured-icon-box icon-align-before-content style4 active bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
              <div className="featured-content p-4">
                <div className="featured-title text-center mb-4">
                  <h3 className="text-lg font-semibold text-teal-500 flex justify-center items-center space-x-2">
                    <HiDocumentText className="text-teal-500" size={20} />
                    <a
                      href={doc.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="f18"
                    >
                      {doc.title}
                    </a>
                  </h3>
                </div>
                <div className="featured-desc text-center">
                  <p>
                    <a
                      href={doc.link}
                      className="btn btn-light bg-teal-500 text-white py-2 px-4 rounded-lg hover:bg-teal-600 transition"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default SchemeSyllabus;
